import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, Input, OnChanges, PLATFORM_ID } from '@angular/core';
import { ReviewIdEnum } from '@app/core';
import { CookieStorage } from '@inshared/shared/util-storage';

@Component({
    selector: 'ins-mening-button',
    templateUrl: 'mening-button.component.html',
})

export class MeningButtonComponent implements OnChanges {
    @Input() reviewId: ReviewIdEnum;
    @Input() bron = 'sale';

    public url: string;

    constructor(
        private cookieStorage: CookieStorage,
        @Inject(PLATFORM_ID) private platformId: Object,
    ) {}

    ngOnChanges(): void {
        if (isPlatformBrowser(this.platformId)) {
            this.url = this.createUrl();
        }
    }

    private createUrl(): string {
        const cynolyticsValue = this.cookieStorage.getItem('__cynolytics') || null;
        return `https://survey.insocial.nl/classic/?sId=${this.reviewId}&sToken=w9pstr74wz&reset=1&var1=&var2=&var3=${cynolyticsValue}&var4=${this.bron}`;
    }
}
